import React from 'react';

export default function ClaimsPage() {
    return (
        <section id="body">
            <div className="container">
                
                <div className="row shadow title position-relative">
					<div className="col-12">
						<h2 className="text-center m-5 text-white font-weight-bold">Lodgment of Claims Conditions</h2>
					</div>
				</div>
			<div className="row content ">
					<div className="col-1"></div>
					<div className="col-10 shadow bg-white rounded">
						<div className="row my-3">
                            <label className="col-11 col-form-label">
                                <b>Step 1</b><br></br>
                                Download & fill up the  <a href="storage/pdf/CI_Claim_Form.pdf" target="_blank">Critical Illness Claim Form</a><br></br>
                                <b>Step 2</b><br></br>
                                Submit the Critical Illness Claim Form along with the supporting documents to <a href="mailto:instaPol@howdengroup.com">instaPol@howdengroup.com</a><br></br>
                                <b>Step 3</b><br></br>
                                Your claim will be reviewed by the Insurer and if approved, payment will be made accordingly.<br></br>
                            </label>
                        </div>                    			
                </div>
            </div>
	</div>
            <div className="row footer my-5">
				<div className="col-12 text-right">
					<a className="btn btn-success mr-3" href="/Landing">Return to Home Page</a>
					<a className="btn btn-success" href="/critical-safe">Get Quote</a>
				</div>
			</div>
        </section>
    );
}